export default __webpack_public_path__ + "static/media/partners6.ead15501.png";